export default __webpack_public_path__ + "static/media/empty_medias.8f0edad0.png";